import axios from 'axios';

const qyxx = (data) => axios.get('/custom/figure/mine', data);    //企业形像

export default {
  qyxx,

}
